/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { useCallback, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { getConfigValue } from "../../sharedServices/configService";
import { findDeepestSubPath } from "../../utility";
import BreadCrumb from "./BreadCrumb";

const ContentHeader = ({ licenseResult, modules = [], location }) => {
	const [isForceClosed, setIsForceClosed] = useState(false);
	const [activeModule, setActiveModule] = useState(undefined);
	const [activeSubPath, setActiveSubpath] = useState(undefined);

	const validateForceClose = useCallback(async () => {
		const configValue = await getConfigValue("IsForceClosed");
		setIsForceClosed(configValue && configValue.IsForceClosed);
	}, []);

	useEffect(() => {
		validateForceClose();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	useEffect(() => {
		const newSelectedModule = modules?.find((m) => location.pathname.startsWith(m.path));
		if (newSelectedModule) {
			let newSelectedSubPath = findDeepestSubPath(newSelectedModule);
			setActiveModule(newSelectedModule);
			setActiveSubpath(newSelectedSubPath);
		} else {
			setActiveModule(undefined);
			setActiveSubpath(undefined);
		}
	}, [location.pathname, modules]);

	return (
		<div className="d-flex flex-column mt-2" style={{ gap: 10 }}>
			{licenseResult === "Warning" && (
				<div className="m-0 alert alert-warning" role="alert">
					Your PACE license has not been verified. Please contact your administrator for assistance.
				</div>
			)}
			{licenseResult !== "Warning" && licenseResult !== "Success" && (
				<div className="m-0 alert alert-danger" role="alert">
					Your PACE license has expired. Please contact your administrator for assistance.
				</div>
			)}
			{isForceClosed && (
				<div className="alert alert-danger m-0" role="alert">
					<i className="fas fa-exclamation-triangle" /> Contact center forced closed
				</div>
			)}
			<BreadCrumb selectedModule={activeModule} selectedSubPath={activeSubPath} />
		</div>
	);
};

export default withRouter(ContentHeader);
